import { Component } from '@angular/core'

@Component({
  selector: 'se-po-team-list-docs',
  templateUrl: './team-list-docs.component.html',
  styleUrls: ['./team-list-docs.component.scss'],
  standalone: false,
})
export class TeamListDocsComponent { }
